import { gql } from '@apollo/client';

export const START_STEP_UP_AUDIT_SESSION_MUTATION = gql`
  mutation StartStepUpAuditSession($input: AuditStepUpInput!) {
    startStepUpAuditSession(input: $input) {
      audit_token
      expires_in_seconds
    }
  }
`;

export const SET_AUDIT_PIN_MUTATION = gql`
  mutation SetAuditPin($input: SetAuditPinInput!) {
    setAuditPin(input: $input) {
      ok
    }
  }
`;

export const AUDIT_LOGS_QUERY = gql`
  query AuditLogs(
    $offset: Int
    $limit: Int
    $module: String
    $action: String
    $reference_kind: String
    $reference_id: String
    $actor_user_id: String
    $from: DateTime
    $to: DateTime
  ) {
    auditLogs(
      offset: $offset
      limit: $limit
      module: $module
      action: $action
      reference_kind: $reference_kind
      reference_id: $reference_id
      actor_user_id: $actor_user_id
      from: $from
      to: $to
    ) {
      items {
        id
        actor_user_id
        actor_role
        workstation_id
        module
        action
        reference_kind
        reference_id
        amount_cents
        reason
        previous_state_json
        new_state_json
        metadata_json
        correlation_id
        ip
        created_at
      }
      page {
        total
        offset
        limit
        has_more
      }
    }
  }
`;
